import React from 'react';

interface TiktokIconProps {
  className?: string;
}

const TiktokIcon: React.FC<TiktokIconProps> = ({ className }) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    aria-label="TikTok icon"
  >
    {/* 
      This is just a sample TikTok path. 
      You can replace it with any official or custom SVG path you prefer.
    */}
    <path d="M12.77 2a3 3 0 0 0-.25.01H9.5v14.5a2.25 2.25 0 1 1-2.25-2.25c.22 0 .44.03.65.1v-2.13a4.45 4.45 0 0 0-.65-.05 4.5 4.5 0 1 0 4.5 4.5V7.13c.5.13 1.17.22 2 .22h.13a4.5 4.5 0 0 0 1.12-2.4C14.2 4.52 13.33 4 12.77 4V2Z" />
  </svg>
);

export default TiktokIcon;
